import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "form"];

  toggle(e) {
    e.preventDefault();
    e.stopPropagation();

    this.menuTarget.classList.toggle("hidden");
    document.body.classList.toggle("overflow-hidden");
  }

  close(e) {
    e.preventDefault();
    this.menuTarget.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");
  }

  applyFilters(e) {
    e.preventDefault();
    this.formTarget.submit();
  }

  clearAll(e) {
    e.preventDefault();
    // Uncheck all checkboxes
    this.formTarget.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
      cb.checked = false;
    });
    // Reset sort to default
    const sortSelect = this.formTarget.querySelector('select[name="sort"]');
    if (sortSelect) {
      sortSelect.value = "newest";
    }
    this.formTarget.submit();
  }

  removeFilter(e) {
    e.preventDefault();
    const filterType = e.currentTarget.dataset.filterType;
    const filterId = e.currentTarget.dataset.filterId;

    // Find and uncheck the corresponding checkbox
    const checkbox = this.formTarget.querySelector(
      `input[name="${filterType}[]"][value="${filterId}"]`
    );
    if (checkbox) {
      checkbox.checked = false;
    }

    this.formTarget.submit();
  }
}
